import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  DialogActions,
  Typography,
  Dialog,
  TextField,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import CustomButton from '../../../../../../../lib/designSystem/Button';
import HeaderWithActions from '../../../../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../../../../lib/designSystem/Table';
import { createFundInvoicesBuyBack } from '../../../../../../../lib/api/funds';
import {
  formatDate,
  showAlert,
} from '../../../../../../../lib/functions/utils';

const MultiBuyBack = (props: any) => {
  const {
    open,
    setOpen,
    payments,
    setSelected,
    callBackCreatePendingAccounts,
  } = props;
  const dispatch = useDispatch();
  const [openBuyBack, setOpenBuyBack] = useState(false);
  const newOperationDate = new Date();
  // Set to 12:00:00
  newOperationDate.setUTCHours(12);
  const [paymentDate, setPaymentDate] = useState<any>(newOperationDate);

  const validParams = () => {
    if (!paymentDate) {
      alert('Debes seleccionar una fecha');
      return false;
    }
    return true;
  };

  const handleBuyBackInvoices = async () => {
    try {
      if (!validParams()) {
        return;
      }
      const paymentsWithDate = payments.map((payment: any) => ({
        ...payment,
        date: paymentDate,
      }));
      const { factoringResellsPaid, date } = await createFundInvoicesBuyBack(
        dispatch,
        {
          factoringNewResells: paymentsWithDate,
        },
      );
      setOpenBuyBack(false);
      showAlert(dispatch, 'success', 'Facturas recompradas correctamente');
      setOpen(false);
      setSelected([]);
      await callBackCreatePendingAccounts(factoringResellsPaid, date);
    } catch (error) {
      setOpenBuyBack(false);
      setOpen(false);
      showAlert(dispatch, 'error', 'Error al recomprar facturas');
      setSelected([]);
    }
  };

  const DateSelector = () => {
    return (
      <div>
        <TextField
          label="Fecha"
          value={paymentDate ? formatDate(paymentDate) : null}
          type="date"
          onChange={(event) => setPaymentDate(event.target.value)}
        />
      </div>
    );
  };

  return (
    <Dialog maxWidth="md" fullWidth open={open}>
      <div style={{ padding: 20, minHeight: 200 }}>
        <div>
          <HeaderWithActions title="Recomprar facturas" item={DateSelector()} />
          <div style={{ padding: '10px 0px' }}>
            <EnhancedTable
              data={payments}
              dataHeaders={[
                {
                  key: 'factoringResellId',
                  label: 'Id',
                  type: 'numeric-id',
                },
                {
                  key: 'folio',
                  label: 'Folio',
                },
                {
                  key: 'businessName',
                  label: 'Cliente',
                },
                {
                  key: 'stakeholderName',
                  label: 'Deudor',
                },
                {
                  key: 'fundName',
                  label: 'Fondo',
                },
                {
                  key: 'documentAmount',
                  label: 'Monto Documento',
                  type: 'money',
                },
              ]}
            />
          </div>
          <DialogActions>
            <CustomButton onClick={() => setOpen(false)} color="secondary">
              Salir
            </CustomButton>
            <CustomButton onClick={() => setOpenBuyBack(true)} color="primary">
              Recomprar
            </CustomButton>
          </DialogActions>
        </div>
      </div>
      <Dialog open={openBuyBack} onClose={() => setOpenBuyBack(false)}>
        <HeaderWithActions title="Recomprar" />
      </Dialog>
      <Dialog open={openBuyBack} onClose={() => setOpenBuyBack(false)}>
        <DialogTitle>
          <Typography variant="h6">Recomprar Facturas</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Estás seguro de querer recomprar las facturas?
          </Typography>
        </DialogContent>
        <DialogActions>
          <CustomButton onClick={() => setOpenBuyBack(false)} color="secondary">
            Cancelar
          </CustomButton>
          <CustomButton onClick={() => handleBuyBackInvoices()} color="primary">
            Confirmar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default MultiBuyBack;
